<template>
  <main>
    <loading-container :loading="loading" height="99">
      <div class="body">
        <div class="top">
          <div class="top__title column">
            <div class="name">
              Об организации
            </div>
          </div>
          <div class="top__title column">
            <div class="name">
              Руководитель организации
            </div>
          </div>
          <div class="top__title column right">
            <div class="top__title-radio">

            </div>
          </div>
        </div>
        <div class="content">
          <div class="column">
            <table>
              <tr>
                <td>Юридическое название компании</td>
                <td>{{entity.company_name}}</td>
              </tr>
              <tr>
                <td>ИНН</td>
                <td>{{entity.inn}}</td>
              </tr>
              <tr v-if="entity.type == 1">
                <td>КПП</td>
                <td>{{entity.kpp}}</td>
              </tr>
              <tr>
                <td>{{entity.type == 1 ? 'ОГРН' : 'ОГРНИП'}}</td>
                <td>{{entity.ogrn}}</td>
              </tr>
              <tr>
                <td>Телефон</td>
                <td>{{entity.phone}}</td>
              </tr>
              <tr>
                <td>E-mail</td>
                <td>{{entity.email}}</td>
              </tr>
              <tr>
                <td>Тип</td>
                <td>{{entity.type == 1 ? 'Юр. лицо' : 'ИП'}}</td>
              </tr>
              <tr>
                <td>{{entity.type == 1 ? 'Юридический адрес' : 'Адрес проживания'}}</td>
                <td>{{getAddressString('legal', entity)}}</td>
              </tr>
              <tr>
                <td>Почтовый адрес</td>
                <td>{{getAddressString('mail', entity)}}</td>
              </tr>
            </table>
          </div>

          <div class="column">
            <table>
              <tr>
                <td>Должность</td>
                <td>{{entity.position}}</td>
              </tr>
              <tr>
                <td>Фамилия</td>
                <td>{{entity.surname}}</td>
              </tr>
              <tr>
                <td>Имя</td>
                <td>{{entity.name}}</td>
              </tr>
              <tr>
                <td>Отчество</td>
                <td>{{entity.patronymic}}</td>
              </tr>
              <tr>
                <td>Действует на основании</td>
                <td>{{entity.act}}</td>
              </tr>
              <tr>
                <td>Дата выдачи</td>
                <td>{{entity.date}}</td>
              </tr>
              <tr>
                <td>Срок действия</td>
                <td>{{entity.date_from}} - {{entity.date_to}}</td>
              </tr>
            </table>
          </div>
          <div class="column right">

          </div>
        </div>

        <div class="top__title column" style="margin-top: 20px; margin-bottom: 10px;" v-if="entity.requisites.length > 0">
          <div class="name">
            Счета
          </div>
        </div>
        <div style="margin-bottom: 20px;" v-for="requisite in entity.requisites" :key="'requisite-' + requisite.id">
          <div class="column">
            <table>
              <tr>
                <td>Название счета</td>
                <td>{{requisite.name}}</td>
              </tr>
              <tr>
                <td>Расчетный счет</td>
                <td>{{requisite.checking_account}}</td>
              </tr>
              <tr>
                <td>Корреспондентский счет</td>
                <td>{{requisite.correspondent_account}}</td>
              </tr>
              <tr>
                <td>БИК</td>
                <td>{{requisite.bik}}</td>
              </tr>
              <tr>
                <td>Название банка</td>
                <td>{{requisite.bank}}</td>
              </tr>
              <tr>
                <td>Адрес банка</td>
                <td>{{requisite.bank_address}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </loading-container>
  </main>
</template>

<script>


import LoadingContainer from "@/components/loading-container";

export default {
  name: "profile-entity",
  components: {LoadingContainer},
  data: ()=>({
    entity: [],
    loading: true
  }),
  mounted() {
    this.getEntity();
  },
  methods: {
    getEntity() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-profile-entity', {
          token: localStorage.getItem('token'),
          id: this.$route.params.id,
        }).then(({data}) => {
          if (data.entity) {
            this.entity = data.entity;
          }
        }).catch((error) => {
          console.log(error)
        }).finally(()=> this.loading = false)
      }
    },
    getAddressString(type = 'legal', entity){
      if(entity[type +'_address_country'] != null && entity[type +'_address_city'] != null && entity[type +'_address_house'] != null) {
        return `${entity[type + '_index'] ? entity[type + '_index'] + ', ' : ''}${entity[type + '_address_country']}, ${entity[type + '_address_city']}, ${entity[type + '_address_region'] ? entity[type + '_address_region'] : ''}, ул.${entity[type + '_address_street']}, д.${entity[type + '_address_house']}${entity[type + '_address_corps'] ? (', к.'+entity[type + '_address_corps']) : ''}${entity[type + '_address_flat'] ? ', офис '+entity[type + '_address_flat'] : ''}`
      }else{
        return 'Не указано'
      }
    },
  }

}
</script>

<style scoped lang="scss">
.btn{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  button{
    background: #2CB181;
    border-radius: 4px;
    height: 50px;
    width: 25%;
    border: none;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #FFFFFF;
  }
}
.wrap{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 20px;
  .column-card{
    padding: 17px;
    width: 49.5%;
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    margin-bottom: 17px;
    &.dis{
      opacity: 0.3;
    }
    .body{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 17px 0 10px 0;
      .item{
        text-align: left;
        p{
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #7A818F;
          margin: 5px 0;
          &.bold{
            color: #2D3137;
          }
        }
      }
      .status{
        text-align: right;
        p{
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: #7A818F;
          margin-bottom: 5px;
          &.active{
            color: #2CB181;
          }
          &.base{
            color: #F39220;
          }
        }
      }
    }
    .top{
      padding: 0;
      margin: 0 -17px 0 -17px;
      border-bottom: 1px solid #D5D9E0;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: auto;
      h3{
        margin-top: -16px;
        margin-left: 17px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #2D3137;
      }
      .buttons {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: -16px;
        padding-right: 20px;
        button {
          height: 20px;
          border: none;
          background: none;
          cursor: pointer;
          outline: none;
          margin: 0 0 0 10px;
          > img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

  }


}

main {
  margin: 30px;
  width: 100%;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
.double{
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  .calendar{
    width: 49%;
  }
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  height: 100%;
  button{
    background: #2CB181;
    border-radius: 4px;
    height: 40px;
    width: 60%;
    margin-top: 600px;
    border: none;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #FFFFFF;
  }
}
.body{
  .top{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
    &__title{
      display: flex;
      flex-wrap: wrap;
      .name{
        display: flex;
        align-items: center;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #2D3137;
        margin-right: 30px;
      }
      .status{
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #2CB181;
      }
      &-radio{
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        display: flex;
        width: max-content;
        background-color: white;
        border-radius: 4px;
        border: 1px solid #EEF0F3;

        &-item {
          cursor: pointer;
          padding: 10px 15px;
          margin: 2px;
          color: #7A818F;
        }
        &-item.active {
          color: #2D3137;
          background: #EEF0F3;
          border-radius: 4px;
        }
      }
    }
  }
  .content{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    input{
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #7A818F;
      padding-left: 10px;
      width: 100%;
      height: 40px;
      background: #FFFFFF;
      border: 1px solid #EEF0F3;
      box-sizing: border-box;
      border-radius: 4px;
      &.about{
        height: 117px;
      }
      &:disabled{
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #7A818F;
        background: #EEF0F3;
      }
    }
    .sec{
      margin-top: 126px;
    }
    .dis{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #7A818F;
    }
    .btn{
      width: 100%;
      padding: 0;
      margin-top: 15px;
      button{
        width: 100%;
        height: 50px;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
        background: #2CB181;
        border-radius: 4px;
        border: none;
      }
    }
    .password{
      position: relative;
      button{
        margin-top: 10px;
        width: 20px;
        height: 20px;
        position: absolute;
        right: 15px;
        top: 20%;
        transform: translateY(-50%);
        background-color: transparent;
        border: none;
        background-image: url('../../assets/img/main/eye.svg');
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        cursor: pointer;

      }
    }
    .calendar{
      position: relative;
      button{
        margin-top: 10px;
        width: 20px;
        height: 20px;
        position: absolute;
        right: 15px;
        top: 20%;
        transform: translateY(-50%);
        background-color: transparent;
        border: none;
        background-image: url('../../assets/img/main/calendar.svg');
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        cursor: pointer;

      }
    }
    .logo{
      height: 61px;
      background: #FFFFFF;
      box-shadow: 0px 0px 3px #E5E5EA;
      border-radius: 4px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 15px;
      button{
        background: #FFFFFF;
        width: 85%;
        height: 40px;
        border: 1px solid #B6BCC8;
        box-sizing: border-box;
        border-radius: 4px;
        font-style: normal;
        font-size: 12px;
        line-height: 14px;
        color: #7A818F;
        margin-left: 15px;
      }
      img{
        width: 44px;
        height: 44px;
      }
    }
    .checkbox {
      display: flex;
      align-items: center;
      position: relative;
      padding-left: 35px;
      margin: 10px 0 12px 0;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #7A818F;
    }
    .checkbox input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
    .checkmark {
      position: absolute;
      left: 0;
      height: 20px;
      width: 20px;
      background-color: #eee;
      box-shadow: 0px 0px 3px #E5E5EA;
      border-radius: 4px;
    }
    .checkbox:hover input ~ .checkmark {
      background-color: #ccc;
    }
    .checkbox input:checked ~ .checkmark {
      background-color: #ccc;
    }
    .checkmark:after {
      content: "";
      position: absolute;
      display: none;
    }
    .checkbox input:checked ~ .checkmark:after {
      display: block;
    }
    .checkbox .checkmark:after {
      left: 8px;
      top: 4px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }

  }

}

.input-block {
  margin-bottom: 15px;
}

.column{
  width: 33%;
}

.modal-form {
  padding: 20px;
}


</style>